import OrderDetails from './OrderDetails.styled';

export default OrderDetails;
